var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_292423)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_632_292423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 0C2.24184 0 -0.00195312 2.24379 -0.00195312 5.01172C-0.00195312 7.77965 2.24184 10.0234 5.00977 10.0234C7.7777 10.0234 10.0215 7.77965 10.0215 5.01172C10.0215 2.24379 7.7777 0 5.00977 0V0ZM7.19091 6.81374C7.07553 7.01348 6.82014 7.08198 6.62041 6.9666L4.60361 5.80221C4.46725 5.72349 4.39207 5.5794 4.39489 5.43239C4.39489 5.43062 4.39479 5.42884 4.39479 5.42707V3.09818C4.39479 2.86754 4.58179 2.68054 4.81243 2.68054C5.04307 2.68054 5.23007 2.86754 5.23007 3.09818V5.19924L7.03815 6.24314C7.23779 6.35851 7.30628 6.6139 7.19091 6.81374V6.81374Z",
    fill: "#CDCDCD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_292423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_632_292423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameTime);
export default __webpack_public_path__ + "static/media/game_time.80e00c5bb6e252cc012af3de19c42852.svg";
export { ForwardRef as ReactComponent };